import { useTranslate } from '@ur-solutions/react-hooks'
import { useState } from 'react'
import type { AbsenceDetailsNode } from '../absence-details'
import { AbsenceDetailsCard } from '../absence-details-card'
import { AbsenceCommentCard } from './card-list/absence-comment-card'
import { CreateAbsenceComment } from './create-comment'

interface Props {
  absence: AbsenceDetailsNode
}

export function AbsenceComments({ absence }: Props) {
  const translations = useTranslate({
    comments: 'absence.details.comments',
  })

  const [editingCommentId, setEditingCommentId] = useState<string | null>(null)

  return (
    <AbsenceDetailsCard
      type="comments"
      title={translations.comments}
      icon="comment"
    >
      <div className="divide-y divide-stone-200">
        {!!absence.comments.length && (
          <div className="divide-y divide-stone-200">
            {absence.comments.map(comment => (
              <AbsenceCommentCard
                key={comment.id}
                data={comment}
                editing={editingCommentId === comment.id}
                onChangeEditing={editing => {
                  setEditingCommentId(editing ? comment.id : null)
                }}
              />
            ))}
          </div>
        )}

        {!editingCommentId && <CreateAbsenceComment absenceId={absence.id} />}
      </div>
    </AbsenceDetailsCard>
  )
}
